import { Card, Grid, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { COLORS } from 'constants/design';
import styled from 'styled-components';

export const StyledWarningContainer = {
  padding: '8px',
  backgroundColor: COLORS.LIGHT_ORANGE,
  marginBottom: 15,
  width: 'fit-content',
};

const styledWarningText = {
  color: COLORS.ORANGE_TEXT,
  fontSize: '14px',
  marginTop: 2,
};

const Container = styled.div`
  @keyframes dots {
    0% {
      content: '.';
    }
    33% {
      content: '..';
    }
    66% {
      content: '...';
    }
  }
  .animated-dots::after {
    content: '.';
    animation: dots 1.2s steps(1, end) infinite;
  }
`;
const WarningCardSkeleton: React.FC = () => {
  return (
    <Container>
      <Card style={StyledWarningContainer} elevation={0}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item>
            <Skeleton variant="rect" width={24} height={24} />
          </Grid>
          <Grid item xs>
            <Typography style={styledWarningText}>
              En cours d'extraction des données
              <span className="animated-dots" />
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default WarningCardSkeleton;
